/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Relationships/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function Relationships({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/PolicyHolder/Options/AddRelationship/Content/Relationship/Relationships",
  isInvalid,
  onChange
  
}) {
let relationshipsValueData = fromData.useDataValue({ viewPath,
context: 'relationships',
})
let newRelationRelationshipTypeValueData = fromData.useDataValue({ viewPath,
context: 'new_relation',
path: 'relationship.type',
})
let newRelationRelationshipTypeIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_relation',
path: 'relationship.type',
validate: fromValidate.text,
required: true,
})
let newRelationRelationshipTypeChangeData = fromData.useDataChange({ viewPath,
context: 'new_relation',
path: 'relationship.type',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 maxWidth={180}
 data="relationships"
 from={relationshipsValueData}
 data="new_relation.relationship.type"
 validate="/Data/validate.js text"
 invalid={!newRelationRelationshipTypeIsValidData}
 required={true}
 value={newRelationRelationshipTypeValueData}
 onChange={newRelationRelationshipTypeChangeData}
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}